import React from 'react';

import { ProjectBlock } from '../../_components/ProjectBlock';
import { ProjectBlockProps } from './types';

import classes from './index.module.scss';

export const ProjectBlockGraphQL: React.FC<ProjectBlockProps> = props => {
  const {
    id,
  } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <ProjectBlock projectBlock={props} />
    </div>
  );
};

export default ProjectBlockGraphQL;
